'use client'

import { cn } from '@mntn-dev/ui-utilities'

export type DividerProps = {
  className?: string
  orientation?: 'horizontal' | 'vertical'
}

export const Divider = ({
  className,
  orientation = 'horizontal',
}: DividerProps) => {
  return orientation === 'horizontal' ? (
    <hr className={cn('w-full h-px border-t border-subtle', className)} />
  ) : (
    <div className={cn('w-px h-full border-l border-subtle', className)} />
  )
}
